export default __webpack_public_path__ + "static/media/play.7917955e.mp3";